import type { ReactNode } from 'react';
import { cssVar } from '@going-once/tokens';
import { Box, Stack, Text } from '../../ui/primitives';

/** The design's overline: a small muted caps heading over a card ("Audit", "Test", "Push"). */
export function Overline({ children }: { children: ReactNode }) {
  return (
    <span style={{ textTransform: 'uppercase', letterSpacing: cssVar('space.xs') }}>
      <Text step="label" tone="fg.muted">
        {children}
      </Text>
    </span>
  );
}

/** A bordered group inside the composer: the Audit card, the Test card, a segment's rules. */
export function Panel({ children, gap = 'md' }: { children: ReactNode; gap?: 'sm' | 'md' | 'lg' }) {
  return (
    <Box
      background="bg.raised"
      radius="md"
      padding="lg"
      style={{ border: `1px solid ${cssVar('color.border.strong')}`, background: 'transparent' }}
    >
      <Stack gap={gap} align="stretch">
        {children}
      </Stack>
    </Box>
  );
}
